import { CountryInfo, SupportedCountry } from '../types';

export const countriesList: Record<SupportedCountry, CountryInfo> = {
    NZ: {
        shortName: 'NZ',
        name: 'New Zealand',
        domain: 'archipro.co.nz',
    },
    AU: {
        shortName: 'AU',
        name: 'Australia',
        domain: 'archipro.com.au',
    },
    US: {
        shortName: 'US',
        name: 'United States',
        domain: 'archipro.design',
    },
};
